export default "__VITE_ASSET__pS$lToLi__"